import gql from 'graphql-tag';
const MULTISELECT_ACTIVITY_FRAGMENT = gql `
  fragment MultiSelectActivityFragment on MultiSelectActivity {
    incorrectAttempt {
      id
      audioId
      audio {
        id
        src
        description
      }
    }
    rounds {
      hint {
        id
        audioId
        audio {
          id
          src
          description
        }
      }
      roundInstructions: instructions {
        id
        audioId
        audio {
          id
          src
          description
        }
      }
      questionHtml {
        id
        elements
      }
      answers {
        id
        label
        correct
      }
      typeOverText {
        id
        text
        directionsHtml {
          id
          elements
        }
        instructions {
          audioId
          audio {
            src
            description
          }
        }
      }
      roundImage: image {
        id
        imageId
        image {
          id
          src
        }
      }
      table {
        labelHtml {
          id
          elements
        }
        headers {
          label
          columnType
        }
        rows {
          values {
            value
            correct
          }
        }
      }
    }
  }
`;
export default MULTISELECT_ACTIVITY_FRAGMENT;
